import type { ReactNode } from 'react';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { xcss, Box, Inline } from '@atlaskit/primitives';

// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer
import Popup from '@atlaskit/popup';
import type { TriggerProps } from '@atlaskit/popup';

import { messages } from '../messages';

const popupContentStyles = xcss({
	paddingBlock: 'space.075',
	paddingInline: 'space.150',
	width: '204px',
	whiteSpace: 'pre-wrap',
});

type PopupTriggerRenderFn = (props: {
	isOpen: boolean;
	togglePopup: () => void;
	triggerProps: TriggerProps;
}) => ReactNode;

type LoomScriptInfoPopupProps = {
	trigger: PopupTriggerRenderFn;
};

export const LoomScriptInfoPopup = ({ trigger }: LoomScriptInfoPopupProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const togglePopup = () => setIsOpen((prev) => !prev);

	return (
		<Popup
			shouldRenderToParent
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			placement="bottom-start"
			content={() => (
				<Box>
					<Inline xcss={popupContentStyles}>
						<FormattedMessage {...messages.loomScriptJustification} />
					</Inline>
				</Box>
			)}
			trigger={(triggerProps) => trigger({ isOpen, togglePopup, triggerProps })}
		/>
	);
};
